module.exports = __webpack_public_path__ + "static/media/year2025_1-tc.08f38c69.jpg";